import {ChevronRightIcon, HomeIcon} from "@heroicons/react/24/outline";

export default function Breadcrumbs({activeCustomer, gender, selectedCase, setActiveCustomer, setGender, setSelectedCase}) {
    function reset() {
        // TODO - reset other nav elements here.
        setActiveCustomer(null);
        setGender("");
        setSelectedCase(null);
    }

    function resetAfterCustomer() {
        setGender("");
        setSelectedCase(null);
    }

    function resetAfterGender() {
        setSelectedCase(null);
    }

    return (
        <nav className="flex" aria-label="Breadcrumb">
            <ol role="list" className="flex items-center space-x-4">
                <li>
                    <div>
                        <a href="#" onClick={() => reset()} className="text-gray-400 hover:text-gray-500">
                            <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                            <span className="sr-only">Home</span>
                        </a>
                    </div>
                </li>
                {activeCustomer !== null && <li key={activeCustomer.company_name}>
                    <div className="flex items-center">
                        <ChevronRightIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true"/>
                        <a
                            href="#"
                            className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                            onClick={() => resetAfterCustomer()}
                        >
                            {activeCustomer.company_name || "poopy"}
                        </a>
                    </div>
                </li>}
                {gender !== "" && <li key={gender}>
                    <div className="flex items-center">
                        <ChevronRightIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true"/>
                        <a
                            href="#"
                            className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                            onClick={() => resetAfterGender()}
                        >
                            {gender}
                        </a>
                    </div>
                </li>}
                {selectedCase !== null && <li key={selectedCase['eval_data']['case_num']}>
                    <div className="flex items-center">
                        <ChevronRightIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true"/>
                        <a
                            href="#"
                            className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                            {selectedCase['eval_data']['case_num']}
                        </a>
                    </div>
                </li>}
            </ol>
        </nav>
    )
}